function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import ScrollTrack from "./ScrollTrack";
import { breakWidth600 } from "@churchofjesuschrist/eden-style-constants";
import SubNavigationItem from "./SubNavigationItem";
const smallHeight = "2.25rem";
const largeHeight = "2.75rem";
const Root = styled.div.withConfig({
  componentId: "sc-1iz9icq-0"
})(["height:calc(", " - 1px);@media (min-width:", "){height:calc(", " - 3px);}"], smallHeight, breakWidth600, largeHeight);
const Items = styled.div.withConfig({
  componentId: "sc-1iz9icq-1"
})(["display:flex;"]);

const SubNavigationNav = _ref => {
  let {
    items = [],
    ...props
  } = _ref;
  const [activeIndex, setActiveIndex] = useState(null);
  return /*#__PURE__*/React.createElement(Root, props, /*#__PURE__*/React.createElement(ScrollTrack, null, /*#__PURE__*/React.createElement(Items, null, items.map((_ref2, index) => {
    let { ...item
    } = _ref2;
    return /*#__PURE__*/React.createElement(SubNavigationItem, _extends({}, item, {
      onOpen: index => setActiveIndex(index),
      onClose: index => {
        setActiveIndex(next => {
          if (next === index) {
            return null;
          } else {
            return next;
          }
        });
      },
      activeIndex: activeIndex,
      index: index,
      key: index
    }));
  }))));
};

SubNavigationNav.propTypes = {
  /** Items to display as links at the end. Any other props are sent through to the root. */
  items: PropTypes.arrayOf(PropTypes.shape({
    /** The text to display */
    text: PropTypes.string.isRequired,

    /** The href */
    href: PropTypes.string,

    /** Whether the item is current. */
    current: PropTypes.bool,

    /** Items to show in a callout. Any other props are passed through to the link. */
    items: PropTypes.arrayOf(PropTypes.shape({
      /** The text to display */
      text: PropTypes.string.isRequired,

      /** The href */
      href: PropTypes.string,

      /** Whether the item is current. */
      current: PropTypes.bool
    }))
  }))
};
export default SubNavigationNav;